// Stable, non-uuid-keyed branding assets. Kept out of the OTA bundle so
// cellular updates stay small.

export const MAIA_PNG = 'https://assets.underlings.com/special/maia.png';
export const MAP_BG_PNG = 'https://assets.underlings.com/special/map-bg.png';
export const LOGO_MARK_PNG = 'https://assets.underlings.com/special/logo-mark.png';
export const ONBOARDING_HERO = [
  'https://assets.underlings.com/special/onboarding/sc-1.jpg',
  'https://assets.underlings.com/special/onboarding/sc-2.jpg',
  'https://assets.underlings.com/special/onboarding/sc-3.jpg',
] as const;
